import { createListenerMiddleware } from '@reduxjs/toolkit';
import {
  onFileUpload,
  onFileUploadSuccess,
} from '../hoc/geographical/store/slices/geographical';
import {
  onCalculate,
  onCalculateSuccess,
} from '../hoc/risk-levels/store/slices/list';

const riskScoreMiddlewares = createListenerMiddleware();

riskScoreMiddlewares.startListening({
  actionCreator: onFileUpload,
  effect: async (action, listenerApi) => {
    setTimeout(() => {
      listenerApi.dispatch(onFileUploadSuccess());
      listenerApi.cancelActiveListeners();
    }, 1000);
  },
});

riskScoreMiddlewares.startListening({
  actionCreator: onCalculate,
  effect: async (action, listenerApi) => {
    setTimeout(() => {
      listenerApi.dispatch(onCalculateSuccess());
      listenerApi.cancelActiveListeners();
    }, 1000);
  },
});

export default riskScoreMiddlewares;
